<template>
  <div class="MailAddressChangeFinish">
    <section-header v-if="isChange" heading="2" ja="メールアドレスの変更が完了しました"/>
    <section-header v-else heading="2" ja="メールアドレスの登録が完了しました"/>
    <div class="mailaddresschange-discription">
      <p v-if="isChange">登録メールアドレスの変更が完了しました。</p>
      <p v-else>メールアドレスの登録が完了しました。</p>
      <p class="description2">{{ mailAddress }}</p>
      <p class="description3">次回ログイン時より、新しいメールアドレスでログインしてください。</p>
    </div>
    <normal-btn @click="onHome">ホームに戻る</normal-btn>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader.vue'
import NormalBtn from '../components/NormalBtn.vue'
import Protobuf from '../mixins/protobuf'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "MailAddressChangeFinish",
  components: {
    NormalBtn,
    SectionHeader
  },
  mixins: [
    Protobuf
  ],
  props: {
    password: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mailAddress: '',
      isChange: false
    }
  },
  methods: {
    onHome() {
      this.$router.push('/')
    }
  },
  mounted() {
    this.isChange = this.$store.getters.mailAddress !== ''

    const cmdNo = pb.PlayerUpdateMailAddressReq.CommandNo.COMMAND_NO
    const message = pb.PlayerUpdateMailAddressReq.create({
      validateKey: this.$route.query.validateKey,
      password: this.password
    })
    const encoded = pb.PlayerUpdateMailAddressReq.encode(message).finish()
    this.post(cmdNo, encoded)
      .then(decoded => {
        if (decoded.status === pb.PlayerUpdateMailAddressResp.Status.SUCCESS) {
          this.mailAddress = decoded.mailAddress
          this.$store.dispatch('saveMailAddress', decoded.mailAddress)
          if(this.password) this.$store.dispatch('savePassword', this.password)
        } else if(decoded.status === pb.PlayerUpdateMailAddressResp.Status.FAILED) {
          this.$_error('Error', { title: 'メールアドレス変更', statusCode: 403 })
        } else if(decoded.status === pb.PlayerUpdateMailAddressResp.Status.EXPIRED) {
          this.$_error('Error', { title: 'メールアドレス変更', statusCode: 402 })
        }
      })
      .catch(() => {
        this.$_error('Error', { title: 'メールアドレス変更', statusCode: 100 })
      })
  }
}
</script>

<style scoped>
.mailaddresschange-discription {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
</style>
